module.exports = __webpack_public_path__ + "static/media/menu-icon.a79e2d47.svg";